import { EDeleteOfferActionTypes, EReorderOffersActionTypes } from '../../actions/compare';
import { TReduxActions } from '../../types/redux';

export function idsReducer(state: number[] = [], action: TReduxActions): number[] {
  switch (action.type) {
    case EDeleteOfferActionTypes.Success: {
      const newState = [...state];
      const { offerId } = action.payload;
      const index = state.findIndex((id: number) => id === offerId);

      if (index === -1) {
        return state;
      }

      newState.splice(index, 1);

      return newState;
    }
    case EReorderOffersActionTypes.ReorderOffers: {
      const { fromIndex, toIndex } = action.payload;
      const newState = [...state];

      const [offerId] = newState.splice(fromIndex, 1);
      newState.splice(toIndex, 0, offerId);

      return newState;
    }
    default:
      return state;
  }
}
